export const GET_COMPANIES = `${BACKOFFICE_API_URL}/companies/fuzzy-search`
export const GET_INCOMING_PAYMENTS = `${BACKOFFICE_API_URL}/incoming-payments`
export const GET_INCOMING_PAYMENT = `${BACKOFFICE_API_URL}/incoming-payments/:id`
export const GET_FORWARD_PAYMENTS = `${BACKOFFICE_API_URL}/incoming-payments/:id/forward-payments`
export const POST_UNMATCH_PAYMENT = `${BACKOFFICE_API_URL}/incoming-payments/:id/unmatch`
export const POST_RESOLVE_PAYMENT = `${BACKOFFICE_API_URL}/incoming-payments/:id/resolve`
export const POST_FORWARD_PAYMENT = `${BACKOFFICE_API_URL}/incoming-payments/:id/forward-payment`
export const POST_SETTLE_INVOICES = `${BACKOFFICE_API_URL}/incoming-payments/:id/settle-invoices`
export const POST_SETTLE_ETPS = `${BACKOFFICE_API_URL}/incoming-payments/:id/settle-etps`
export const BANK_ACCOUNTS = `${BACKOFFICE_API_URL}/companies/:id/bank-accounts`
export const COMMENT_INCOMING_PAYMENT = `${BACKOFFICE_API_URL}/incoming-payments/:id/comment`
export const GET_SEARCH_RESULTS = `${BACKOFFICE_API_URL}/invoices`
export const POST_DEPOSIT = `${BACKOFFICE_API_URL}/incoming-payments/:id/deposit`
export const GET_PAYABLE_SEARCH_RESULTS = `${BACKOFFICE_API_URL}/incoming-payments/:id/matching/etps`

export default {
  GET_COMPANIES,
  GET_INCOMING_PAYMENTS,
  GET_INCOMING_PAYMENT,
  GET_FORWARD_PAYMENTS,
  POST_UNMATCH_PAYMENT,
  POST_SETTLE_INVOICES,
  POST_SETTLE_ETPS,
  POST_FORWARD_PAYMENT,
  BANK_ACCOUNTS,
  COMMENT_INCOMING_PAYMENT,
  POST_DEPOSIT,
  GET_PAYABLE_SEARCH_RESULTS
}
